import { X } from "lucide-react";
import { Avatar, IconButton } from "@akuna/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import type { PatientSearchOption } from "@/hooks/usePatientSearchForQuickStart";
import { maskPhoneInput } from "@/lib/utils/phone-mask";

const photoUrl = (path: string | null | undefined) =>
  path ? supabase.storage.from("pet-photos").getPublicUrl(path).data.publicUrl : undefined;

export function PatientSearchResult({
  option,
  variant,
  onRemove,
  petHref,
}: {
  option: PatientSearchOption;
  variant: "option" | "selected";
  onRemove?: () => void;
  petHref?: string;
}) {
  const { t } = useTranslation("daycareHotel");
  const phone = option.ownerPrimaryPhone?.trim();
  const formattedPhone = phone ? maskPhoneInput(phone) : null;

  return (
    <div className="flex min-w-0 flex-1 items-center gap-3">
      <Avatar
        className={variant === "selected" ? "h-11 w-11" : "h-10 w-10"}
        name={option.petName}
        src={photoUrl(option.petPhotoPath)}
        fallback={option.petName?.slice(0, 1) ?? "P"}
      />
      <div className="min-w-0 flex-1">
        {petHref ? (
          <Link to={petHref} target="_blank" rel="noopener noreferrer" className="block truncate font-display text-sm font-bold text-primary hover:underline">
            {option.petName}
          </Link>
        ) : (
          <div className="truncate font-display text-sm font-bold text-foreground">{option.petName}</div>
        )}
        <div className="truncate text-xs text-muted-foreground">
          {option.ownerName}
          {formattedPhone ? ` · ${formattedPhone}` : null}
        </div>
      </div>
      {variant === "selected" && onRemove ? (
        <IconButton size="sm" variant="ghost" label={t("remove")} onClick={onRemove}>
          <X size={16} />
        </IconButton>
      ) : null}
    </div>
  );
}
